'use client';

import React from 'react';

interface SocialMediaLogoProps {
  platform: 'facebook' | 'github' | 'linkedin';
  className?: string;
}

const SocialMediaLogo: React.FC<SocialMediaLogoProps> = ({
  platform,
  className,
}) => {
  switch (platform.toLowerCase()) {
    case 'facebook':
      return (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M24.4 12.1055C24.4 5.47805 19.0274 0.105469 12.4 0.105469C5.7726 0.105469 0.400024 5.47805 0.400024 12.1055C0.400024 18.0949 4.78823 23.0595 10.525 23.9597V15.5742H7.47815V12.1055H10.525V9.46172C10.525 6.45422 12.3166 4.79297 15.0576 4.79297C16.3701 4.79297 17.7438 5.02734 17.7438 5.02734V7.98047H16.2306C14.74 7.98047 14.275 8.90555 14.275 9.85547V12.1055H17.6031L17.0711 15.5742H14.275V23.9597C20.0118 23.0595 24.4 18.0949 24.4 12.1055Z"
            fill="#ACAEB4"
          />
        </svg>
      );

    case 'github':
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <g clipPath="url(#clip0)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.4 0.105469C5.77242 0.105469 0.400024 5.48627 0.400024 12.1259C0.400024 17.4359 3.83802 21.9419 8.60682 23.5307C9.20682 23.6411 9.42522 23.2703 9.42522 22.9511C9.42522 22.6667 9.41563 21.9095 9.40963 20.9075C6.07123 21.6335 5.36682 19.2959 5.36682 19.2959C4.82202 17.9063 4.03482 17.5367 4.03482 17.5367C2.94522 16.7927 4.11762 16.8071 4.11762 16.8071C5.32122 16.8911 5.95482 18.0455 5.95482 18.0455C7.02523 19.8815 8.76402 19.3511 9.44682 19.0439C9.55722 18.2675 9.86683 17.7383 10.21 17.4383C7.54602 17.1347 4.74402 16.1027 4.74402 11.4971C4.74402 10.1855 5.21202 9.11147 5.97882 8.27147C5.85522 7.96787 5.44362 6.74507 6.09643 5.09147C6.09643 5.09147 7.10442 4.76747 9.39642 6.32267C10.3753 6.05569 11.3854 5.9197 12.4 5.91827C13.42 5.92307 14.446 6.05627 15.4048 6.32267C17.6956 4.76747 18.7012 5.09027 18.7012 5.09027C19.3564 6.74507 18.9436 7.96787 18.8212 8.27147C19.5892 9.11147 20.0548 10.1855 20.0548 11.4971C20.0548 16.1147 17.248 17.1311 14.5756 17.4287C15.0064 17.7995 15.3892 18.5327 15.3892 19.6547C15.3892 21.2603 15.3748 22.5575 15.3748 22.9511C15.3748 23.2727 15.5908 23.6471 16.2004 23.5295C18.59 22.728 20.6672 21.1958 22.1386 19.1495C23.61 17.1032 24.401 14.6462 24.4 12.1259C24.4 5.48627 19.0264 0.105469 12.4 0.105469Z"
              fill="#ACAEB4"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.400024 0.105469)"
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'linkedin':
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M22.6235 0.105469H2.1719C1.19221 0.105469 0.400024 0.878906 0.400024 1.83516V22.3711C0.400024 23.3273 1.19221 24.1055 2.1719 24.1055H22.6235C23.6031 24.1055 24.4 23.3273 24.4 22.3758V1.83516C24.4 0.878906 23.6031 0.105469 22.6235 0.105469ZM7.52034 20.557H3.95784V9.10078H7.52034V20.557ZM5.73909 7.53984C4.59534 7.53984 3.6719 6.61641 3.6719 5.47734C3.6719 4.33828 4.59534 3.41484 5.73909 3.41484C6.87815 3.41484 7.80159 4.33828 7.80159 5.47734C7.80159 6.61172 6.87815 7.53984 5.73909 7.53984ZM20.8516 20.557H17.2938V14.9883C17.2938 13.6617 17.2703 11.9508 15.4422 11.9508C13.5906 11.9508 13.3094 13.3992 13.3094 14.8945V20.557H9.75628V9.10078H13.1688V10.6664H13.2156C13.6891 9.76641 14.8516 8.81484 16.5813 8.81484C20.186 8.81484 20.8516 11.1867 20.8516 14.2711V20.557Z"
            fill="#ACAEB4"
          />
        </svg>
      );

    default:
      return null;
  }
};

export default SocialMediaLogo;
